/**
 * PDF naar afbeeldingen — client-side conversie voor servergestuurde documentanalyse (geen directe PDF naar tekst).
 *
 * Worker: lokaal via Vite (?url), geen CDN — voorkomt CSP/fetch-fouten op productie (calqtool.com).
 *
 * Legacy-build: de moderne pdf.worker veronderstelt `Uint8Array.prototype.toHex` (nog niet overal aanwezig);
 * zonder polyfill volgt o.a. "n.toHex is not a function" bij PDF-pagina’s renderen.
 */
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf.mjs';
import pdfWorkerUrl from 'pdfjs-dist/legacy/build/pdf.worker.min.mjs?url';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

export async function pdfToImageFiles(file: File): Promise<File[]> {
  const arrayBuffer = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
  const numPages = Math.min(pdf.numPages, 10); // max 10 pages
  const files: File[] = [];

  for (let i = 1; i <= numPages; i++) {
    const page = await pdf.getPage(i);
    const viewport = page.getViewport({ scale: 1.2 });
    const canvas = document.createElement('canvas');
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) continue;
    const task = page.render({ canvasContext: ctx, canvas, viewport });
    await task.promise;
    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, 'image/jpeg', 0.85)
    );
    if (blob) {
      files.push(new File([blob], `page-${i}.jpg`, { type: 'image/jpeg' }));
    }
  }
  return files;
}
